import React, { useMemo } from "react";
import {
  CustomCheckbox,
  SelectInputComponent,
  TextInputComponent,
} from "../../../../common/components";
import "./filter-options-tenant.scss";
import { CompanyNameFilterProps } from "./tenant-filter-helper";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from "@mui/material";

const CompanyNameFilter: React.FC<CompanyNameFilterProps> = ({
  value,
  error,
  onChange,
  isCompanyNameEnabled,
  companyNames,
  isMultiple = true,
  label = "Select Company name",
}) => {
  if (!isCompanyNameEnabled) return null;
  return (
    <div className="tenant-filter-options-text-wrapper-select">
      <FormControl fullWidth error={!!error} size="small">
        <InputLabel className="subscription-label">{label}</InputLabel>
        <Select
          className="subscription-select"
          multiple={isMultiple}
          value={value}
          onChange={(e: SelectChangeEvent<string | string[]>) => {
            const selected = e.target.value;
            onChange(typeof selected === "string" ? [selected] : selected);
          }}
          input={<OutlinedInput label={label} />}
          renderValue={(selected) =>
            Array.isArray(selected) ? selected.join(", ") : selected
          }
        >
          {companyNames.map((company) => (
            <MenuItem
              key={company}
              value={company}
              className="subscription-menu-item"
            >
              <ListItemText primary={company} />
              {isMultiple && (
                <CustomCheckbox
                  checked={value.includes(company)}
                  onChange={() => {
                    const newValue = value.includes(company)
                      ? value.filter((v) => v !== company)
                      : [...value, company];
                    onChange(newValue);
                  }}
                  label={""}
                />
              )}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </div>
  );
};

export default CompanyNameFilter;
